import { Icons } from "react-toastify";
import { SVGICON } from "../../constant/theme";
import { IMAGES } from "../../constant/theme";

const FullMenuList = [
    {
        title: 'Heute',
        classsChange: 'mm-collapse',
        to: '/current-pickups-returns',
        iconStyle: SVGICON.Booking,


    },
    {
        title: 'Dashboard',
        classsChange: 'mm-collapse',
        to: '/dashboard',
        iconStyle: SVGICON.Home,


    },

    {
        // title: <span>Manage Booking <span className="text-danger" style={{ fontWeight: 'bold' }}>1</span></span>,
        title: 'Manage Booking',
        //iconStyle:"fa-brands fa-servicestack" ,
        iconStyle: SVGICON.Booking,
        to: '/admin/payment_details',

    },

    {
        title: 'Restricted Dates',
        iconStyle: <img src={IMAGES.RestrictedDate} style={{width:"17px", height:'17px',marginRight:"10px" ,}} />,
        // iconStyle: SVGICON.Forms,
        to: '/admin/restricted-list',
    },
    {
        title: 'Unavailable Dates',
        iconStyle: <img src={IMAGES.UnavailableDate} style={{width:"17px", height:'17px',marginRight:"10px" ,}} />,
        // iconStyle: SVGICON.Forms,
        to: '/admin/unavailable-list',
    },
    {
        title: 'Minimum Rent Durations',
        iconStyle: <img src={IMAGES.MinimumRent} style={{width:"17px", height:'17px',marginRight:"10px" ,}} />,
        // iconStyle: SVGICON.Forms,
        to: '/admin/minimumrentduration-list',
    },

    {
        title: 'Camper Rent',
        //iconStyle:"fa-brands fa-servicestack" ,
        iconStyle: SVGICON.Camper,
        to: '/admin/campers/Rent',
    },
    {
        title: 'Camper Subscription',
        //iconStyle:"fa-brands fa-servicestack" ,
        iconStyle: SVGICON.Camper,
        to: '/admin/camper_subscription',
    },
    {
        title: 'Camper Sale',
        //iconStyle:"fa-brands fa-servicestack" ,
        iconStyle: SVGICON.Camper,
        // to: '/admin/campers/Sale',
        to: '/admin/camper_sale',
    },

    {
        title: 'Pricing Management',
        //iconStyle:"fa-brands fa-servicestack" ,
        iconStyle: SVGICON.Pricing,
        to: '/admin/pricing_management',
    },
    {
        title: 'Discount Management',
        //iconStyle:"fa-brands fa-servicestack" ,
        iconStyle: SVGICON.Discount,
        to: '/admin/discount',
    },
    {
        title: 'Blog Managment',
        iconStyle: SVGICON.Blog,
        to: '/admin/blogs',

    },
    {
        title: 'Voucher',
        iconStyle: SVGICON.Managment,
        to: '/admin/vouchers',

    },
    {
        title: 'Manage Voucher',
        //iconStyle:"fa-brands fa-servicestack" ,
        iconStyle: SVGICON.Voucher,
        to: '/admin/voucherlist',

    },
    {
        title: 'Manage Travel Planner',
        //iconStyle:"fa-brands fa-servicestack" ,
        iconStyle: SVGICON.Travel,
        to: '/admin/travelplanner',

    },
    {
        title: 'Travel Planner',
        //iconStyle:"fa-brands fa-servicestack" ,
        iconStyle: SVGICON.Managment,
        to: '/admin/manage_travel',

    },
    // {
    //     title: 'Trip Review',
    //     //iconStyle:"fa-brands fa-servicestack" ,
    //     iconStyle: SVGICON.Service,
    //     to: '/admin/trip_review',

    // },
    // {
    //     title: 'Booking Calender Managment',
    //     //iconStyle:"fa-brands fa-servicestack" ,
    //     iconStyle: SVGICON.Service,
    //     to: '/admin/booking_calender',

    // },
    // {
    //     title: 'Booking Details',
    //     iconStyle: SVGICON.Fuel,
    //     to: 'admin/booking',
    // },

    // {
    //     title: 'Accounting System',
    //     //iconStyle:"fa-brands fa-servicestack" ,
    //     iconStyle: SVGICON.Service,
    //     to: '/admin/accounting_system',

    // },
    {
        title: 'Carefree Packages',
        iconStyle: SVGICON.Packages,
        to: '/admin/packages',
    },
    {
        title: 'Carefree Package Items',
        iconStyle: SVGICON.Packages,
        to: '/admin/packagesItem',
    },
    {
        title: 'Cancellation Policy',
        iconStyle: SVGICON.Policy,
        to: '/admin/cancellation-policy',
    },
    {
        title: 'Cancellation Policy Items',
        iconStyle: SVGICON.Packages,
        to: '/admin/cancellation-policy-items',
    },
    {
        title: 'Brand',
        iconStyle: SVGICON.Brand,
        to: '/admin/brand',
    },
    {
        title: 'Services',
        //iconStyle:"fa-brands fa-servicestack" ,
        iconStyle: SVGICON.Service,
        to: '/admin/services',
    },
    {
        title: 'Kitchen',
        iconStyle: SVGICON.Kitchen,
        to: '/admin/kitchen',
    },
    {
        title: 'Driving',
        iconStyle: SVGICON.Driving,
        to: '/admin/driving',
    },
    {
        title: 'Bathroom',
        //iconStyle:"fa-brands fa-servicestack" ,
        iconStyle: SVGICON.Hygiene,
        to: '/admin/bathroom_management',
    },
    {
        title: 'Vehicle',
        //iconStyle:"fa-brands fa-servicestack" ,
        iconStyle: SVGICON.Vehicle,
        to: '/admin/vehicle',
    },
    {
        title: 'Living & Sleeping',
        iconStyle: SVGICON.Living,
        to: '/admin/living',
    },
    {
        title: 'Outdoor Area',
        iconStyle: SVGICON.Outdoor,
        to: '/admin/outdoor',
    },
    {
        title: 'Feature',
        iconStyle: SVGICON.Feature,
        to: '/admin/feature',

    },
    {
        title: 'Banner',
        iconStyle: <img src={IMAGES.Banner} style={{width:"17px", height:'17px',marginRight:"10px" ,}} />,
        // iconStyle: SVGICON.Widget,
        to: '/admin/banner',

    },

    {
        title: 'Deals',
        iconStyle: SVGICON.Deals,
        to: '/admin/deal',

    },
    {
        title: 'Accessories',
        iconStyle: SVGICON.Accessories,
        to: '/admin/accessories',

    },
    {
        title: 'Fuels',
        iconStyle: SVGICON.Fuel,
        to: '/admin/fuel',
    },
    {
        title: 'Kilometer',
        iconStyle: SVGICON.kilometer,
        to: 'admin/kilometer',
    },
    {
        // title: 'Contact',
        title: 'Inquiries',
        iconStyle: SVGICON.Inquiries,
        to: 'admin/contact',
    },
    // {
    //     // title: 'Contact',
    //     title: 'Customer Documents',
    //     iconStyle: SVGICON.CustomerDocuments,
    //     to: 'admin/documents',
    // },
    {
        // title: 'Contact',
        title: 'Customer Database',
        iconStyle: SVGICON.CustomerDatabase,
        to: 'admin/database',
    },
    // {
    //     title: 'Sale Contact',
    //     iconStyle: SVGICON.List,
    //     to: 'admin/salecontact',
    // },
    {
        title: 'Login Accounts',
        iconStyle: SVGICON.UserListing,
        to: 'admin/users',
    },
    {
        title: 'Newsletters',
        iconStyle: SVGICON.Newsletters,
        to: 'admin/newsletters',
    },


]

export function getMenuList() {
    const userData = JSON.parse(localStorage.getItem("user"));
    const userRole = userData?.roles?.map((data) => {
        return data?.name;
    }) || [];

    const isStaff = userRole.some((roleName) =>
        String(roleName || '')
            .trim()
            .toLowerCase() === 'staff'
    );

    const list = isStaff
        ? FullMenuList.filter(item => item.title === 'Heute' || item.title === 'Inquiries')
        : FullMenuList;

    if (!isStaff) return list;

    return list.map((item) => {
        if (item.title !== 'Inquiries') return item;
        return { ...item, label: 'Anfragen' };
    });
}

// Keep backward-compatible export (reads fresh on each access)
export const MenuList = FullMenuList;